<template>
  <div class="schedule-table" tabindex="0">
    <div v-if="uniquePersons.length === 0" class="no-data">
      没有员工信息
    </div>
    <div v-else class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th class="date-header header fixed name-header" :style="{ backgroundColor: headerBcakgroungColor }" rowspan="2">姓名</th>
            <th v-for="month in yearMonths" :key="month.month" :colspan="month.weeks.length" class="month-header"
              :style="{ backgroundColor: headerBcakgroungColor }">
              {{ month.month }}月
            </th>
          </tr>
          <tr>
            <th v-for="week in allWeeks" :key="week.key" class="week-header"
              :style="{ backgroundColor: headerBcakgroungColor }">
              第{{ week.weekIndex + 1 }}周<br />
              {{ week.display }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(person, rowIndex) in getCurrentPagePersons" :key="person.employNo">
            <td class="fixed name-cell" rowspan="1">
              <div style="border-top: 1px solid #ccc;border-right: 1px solid #ccc;height: 100%;display: flex;align-items: center;justify-content: center;">
                {{ person.employName }}
              </div>
            </td>
            <td v-for="(week, colIndex) in allWeeks" :key="colIndex" 
                :class="getCellClass(rowIndex, colIndex)"
                @dblclick="activateEditor(rowIndex, colIndex)">
              
              <template v-if="editingCell && editingCell[0] === rowIndex && editingCell[1] === colIndex">
                <input @blur="handleBlur" placeholder="请输入" ref="myInput" type="text"
                  style="text-align: center; width: 80%;" v-model="localValue[person.employNo][week.key]">
              </template>
              <template v-else>
                
                 <span :style="getCellStyle(localValue[person.employNo]?.[week.key] || '0')">
  {{ localValue[person.employNo]?.[week.key] || '0' }}
</span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="uniquePersons.length > 0" class="pagination">
      <button @click="prevPage" :disabled="currentPage === 1">上一页</button>
      <span>第 {{ currentPage }} 页 / 共 {{ totalPages }} 页</span>
      <button @click="nextPage" :disabled="currentPage === totalPages">下一页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'test-model',
  props: {
    year: {
      type: String,
      default: '2025',
    },
    headerBcakgroungColor: {
      type: String,
      default: '',
    },
    pageNum: {
      type: String,
      default: '10',
    },
    employInfo: {
      type: Array,
      default: () => [
        {
        departNo: "100101",
        employName: "陈玉东",
        employNo: "ZJB001"
    },
    {
        departNo: "100101",
        employName: "李翔xxx",
        employNo: "ZJB002"
    },
    {
        departNo: "100101-1-6",
        employName: "李欣",
        employNo: "QXB-001"
    },
    {
        departNo: "100101-1-4",
        employName: "李超群",
        employNo: "CWB001"
    },
    {
        departNo: "100101-1-3",
        employName: "姜伟航",
        employNo: "LCB002"
    },
    {
        departNo: "100101-1-3",
        employName: "陈雨",
        employNo: "LCB003"
    },
      ],
    },
    value: {
      type: Array,
      default: () => [
         {
        createdTime: "",
        dates: "2025-01",
        employName: "陈雨",
        employNo: "LCB003",
        id: 3159989233255680,
        value: "100",
        weekValue: "3"
    },
    {
        createdTime: "",
        dates: "2025-01",
        employName: "李翔xxx",
        employNo: "ZJB002",
        id: 3167766475085824,
        value: "8",
        weekValue: "4"
    },
    {
        createdTime: "",
        dates: "2025-02",
        employName: "李翔xxx",
        employNo: "ZJB002",
        id: 3167766686283776,
        value: "1",
        weekValue: "1"
    }
      ],
    },
  },
  data() {
    return {
      localValue: {},
      currentPage: 1,
      pageSize: parseInt(this.pageNum) || 10,
      yearMonths: [],
      allWeeks: [],
      editingCell: null,
    };
  },
  computed: {
    uniquePersons() {
      const uniqueMap = new Map();
      this.employInfo.forEach(person => {
        if (!uniqueMap.has(person.employNo)) {
          uniqueMap.set(person.employNo, {
            employNo: person.employNo,
            employName: person.employName
          });
        }
      });
      return Array.from(uniqueMap.values());
    },
    getCurrentPagePersons() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.uniquePersons.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.uniquePersons.length / this.pageSize);
    }
  },
  watch: {
    pageNum: {
      handler(newVal) {
        this.pageSize = parseInt(newVal) || 10;
        this.currentPage = 1;
      },
      immediate: true
    },
    year: {
      handler() {
        this.calculateYearWeeks();
        this.initLocalValue();
      },
      immediate: true,
    },
    value: {
      handler() {
        this.initLocalValue();
      },
      deep: true,
      immediate: true,
    },
    employInfo: {
      handler(newVal) {
        // 当 employInfo 发生变化时，重置 currentPage 为 1
        this.currentPage = 1;
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    this.initLocalValue();
    this.calculateYearWeeks();
  },
  methods: {
    calculateYearWeeks() {
      const year = parseInt(this.year, 10);
      this.yearMonths = [];
      this.allWeeks = [];
      
      for (let month = 0; month < 12; month++) {
        const firstDay = new Date(Date.UTC(year, month, 1));
        const lastDayOfMonth = new Date(Date.UTC(year, month + 1, 0));
        const monthName = month + 1;
        
        const monthWeeks = [];
        let weekIndex = 0;
        
        let currentMonday = new Date(firstDay);
        if (currentMonday.getUTCDay() !== 1) {
          const daysToAdd = currentMonday.getUTCDay() === 0 ? 1 : 8 - currentMonday.getUTCDay();
          currentMonday.setUTCDate(currentMonday.getUTCDate() + daysToAdd);
        }
        
        if (currentMonday > lastDayOfMonth) {
          this.yearMonths.push({
            month: monthName,
            weeks: []
          });
          continue;
        }
        
        while (true) {
          let weekEnd = new Date(currentMonday);
          weekEnd.setUTCDate(currentMonday.getUTCDate() + 6);
          
          const weekInfo = this.createWeekInfo(
            monthName, 
            weekIndex, 
            currentMonday, 
            weekEnd
          );
          monthWeeks.push(weekInfo);
          this.allWeeks.push(weekInfo);
          
          const nextMonday = new Date(weekEnd);
          nextMonday.setUTCDate(weekEnd.getUTCDate() + 1);
          
          if (nextMonday > lastDayOfMonth) {
            break;
          }
          
          currentMonday = nextMonday;
          weekIndex++;
        }
        
        this.yearMonths.push({
          month: monthName,
          weeks: monthWeeks
        });
      }
    },
    
    getMonday(dates) {
      const day = dates.getUTCDay();
      const diff = dates.getUTCDate() - day + (day === 0 ? -6 : 1);
      return new Date(dates.setUTCDate(diff));
    },
    
    createWeekInfo(month, weekIndex, startDate, endDate) {
      const key = `${month}-${weekIndex + 1}`;
      const display = startDate.getTime() === endDate.getTime() 
        ? this.formatDate(startDate) 
        : `${this.formatDate(startDate)}-${this.formatDate(endDate)}`;
      
      return {
        month,
        weekIndex,
        start: startDate,
        end: endDate,
        key,
        display
      };
    },
    
    formatDate(dates) {
      return `${(dates.getUTCMonth() + 1).toString().padStart(2, '0')}.${dates.getUTCDate().toString().padStart(2, '0')}`;
    },
    
    initLocalValue() {
      const base = {};
      
      this.uniquePersons.forEach(person => {
        if (!base[person.employNo]) {
          base[person.employNo] = {};
        }
        
        this.allWeeks.forEach(week => {
          if (week.key && !base[person.employNo][week.key]) {
            base[person.employNo][week.key] = '0';
          }
        });
      });

      this.value.forEach(item => {
        try {
          if (!item.dates) return;
          
          const dateParts = item.dates.split('-');
          const month = dateParts.length > 1 ? parseInt(dateParts[1], 10) : null;
          const weekKey = month ? `${month}-${item.weekValue}` : null;
          
          if (weekKey && base[item.employNo] && item.value !== undefined) {
            base[item.employNo][weekKey] = item.value;
          }
        } catch (e) {
          console.error('Error processing value item:', item, e);
        }
      });

      this.localValue = base;
    },
    
    handleBlur() {
      this.editingCell = null;
      this.emitValue();
    },
    
    emitValue() {
      const result = [];
      this.uniquePersons.forEach(person => {
        this.allWeeks.forEach(week => {
          const value = this.localValue[person.employNo][week.key];
          const existingItem = this.value.find(item => {
            const dateParts = item.dates ? item.dates.split('-') : [];
            const month = dateParts.length > 1 ? parseInt(dateParts[1], 10) : null;
            const weekKey = month ? `${month}-${item.weekValue}` : null;
            return item.employNo === person.employNo && weekKey === week.key;
          });
          
          if (value !== '0') {
            if (existingItem) {
              existingItem.value = value;
              result.push(existingItem);
            } else {
              const [month, weekNum] = week.key.split('-');
              const year = this.year || new Date().getFullYear();
              this.value.push({
                id: undefined,
                employNo: person.employNo,
                employName: person.employName,
                value: value,
                weekValue: weekNum,
                dates: `${year}-${month.toString().padStart(2, '0')}`
              });
            }
          }
        });
      });
      
      this.$emit('input', this.value);
      this.$emit('value', this.value);
    },
    
    activateEditor(row, col) {
      this.editingCell = [row, col];
      console.log(this.editingCell)
      this.$nextTick(() => {
        if (this.$refs.myInput) {
          this.$refs.myInput[0].focus();
        }
      });
    },
    
    getCellClass(row, col) {
      const classes = [];
      if (this.editingCell && this.editingCell[0] === row && this.editingCell[1] === col) {
        classes.push('editing');
      }
      return classes;
    },
    
    getCellStyle(value) {
      return {
        color: '',
        backgroundColor: value !== '0' ? '#f0f0f0' : '',
        fontWeight: value !== '0' ? 'bold' : '',
        width: '100%',
        height: '100%',
        borderRadius: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },
    
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  },
};
</script>

<style scoped>
.schedule-table {
  box-sizing: border-box;
  overflow: auto;
  border: 1px solid #ccc;
  outline: none;
}

.no-data {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #888;
}

th {
  font-size: 12px;
}

td span {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.4;
  border-radius: 4px;
  font-family: inherit;
  vertical-align: middle;
  padding: 0;
  font-size: 12px;
  height: 24px;
}

.table-wrapper {
  overflow: auto;
  max-width: 100%;
}

table {
  border-collapse: collapse;
  width: max-content;
  min-width: 100%;
}

th,
td {
  border: 1px solid #ccc;
  width: 100px;
  height: 32px;
  text-align: center;
  user-select: none;
  box-sizing: border-box;
  font-size: 12px;
  padding: 0px;
}

.date-header {
  background-color: rgb(85, 184, 184);
  color: white;
}

.month-header {
  background-color: rgb(85, 184, 184);
  color: white;
  text-align: center;
}

.week-header {
  background-color: rgb(85, 184, 184);
  color: white;
  text-align: center;
}

.fixed.name-header {
  background-color: rgb(85, 184, 184);
  color: white;
  border: 1px solid #ccc;
  position: sticky;
  left: 0;
  z-index: 2;
}

.fixed.name-cell {
  background-color: #fff;
  color: black;
  position: sticky;
  left: 0;
  z-index: 1;
}

.editing {
  background-color: #E0EEFB;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.pagination button {
  margin: 0 5px;
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

input {
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  font-size: 12px;
}
</style>